var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import rowStyles from './RowStyles';
import { injectTestId } from '@cvent/nucleus-test-automation';
var Row = /** @class */ (function (_super) {
    __extends(Row, _super);
    function Row() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Row.prototype.render = function () {
        var _a = this.props, children = _a.children, minHeight = _a.minHeight, flexGrow = _a.flexGrow, justifyContent = _a.justifyContent, isRtl = _a.isRtl, margin = _a.margin, 
        // @ts-expect-error className does not exist in the type but className is filtered out here for JS purposes
        _className = _a.className, testID = _a.testID, zIndex = _a.zIndex, restProps = __rest(_a, ["children", "minHeight", "flexGrow", "justifyContent", "isRtl", "margin", "className", "testID", "zIndex"]);
        var styles = rowStyles({
            zIndex: zIndex,
            minHeight: minHeight,
            justifyContent: justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.toLowerCase(),
            flexGrow: flexGrow,
            isRtl: isRtl,
            margin: margin
        });
        return (_jsx("div", __assign({}, restProps, injectTestId(testID), { css: styles, "data-layout": "row" }, { children: children }), void 0));
    };
    Row.defaultProps = {
        minHeight: 0,
        justifyContent: 'flex-start'
    };
    return Row;
}(React.Component));
export default Row;
